import { render, staticRenderFns } from "./YourStuffPageHeaderEmployeeOnly.vue?vue&type=template&id=12dbea99&scoped=true"
import script from "./YourStuffPageHeaderEmployeeOnly.vue?vue&type=script&setup=true&lang=js"
export * from "./YourStuffPageHeaderEmployeeOnly.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourStuffPageHeaderEmployeeOnly.vue?vue&type=style&index=0&id=12dbea99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dbea99",
  null
  
)

export default component.exports